import React, { useEffect, useState, useRef } from 'react';
import { ConfirmationModal, SimpleModal } from '../../../common/components/Modal';
import { I18n } from 'react-redux-i18n';
import ContractCard from '../ContractCard/ContractCard';
import ProductRegistrationCard from '../ProductRegistrationCard/ProductRegistrationCard';
import './VolumeRegistrationScreen.scss';
import { connect } from 'react-redux';
import actions from '../../../actions';
import { KeyManager } from 'jasper-roche-crypto';
import TransactionsSuccessModal from '../../../transaction/components/TransactionsSuccessModal';

import Button from '../../../common/components/Button';

const VolumeRegistrationScreen = ({
    contracts,
    getContractOs,
    getOSContracts,
    getVolumeContracts,
    volumeContracts,
    username,
    registerProductByVolume, // new action
    registerProductByVolumeStatus, // loading / error flags
    clearVolumeRegistrationUI, // clear UI status
    clearVolumeRegistrationError, // clear error status
}) => {
    const [selectedContract, setSelectedContract] = useState(null);
    const [selectorOpen, setSelectorOpen] = useState(false);
    const [confirmSaveOpen, setConfirmSaveOpen] = useState(false);
    const [pendingTrace, setPendingTrace] = useState(null);

    useEffect(() => {
        getVolumeContracts(); // loads addable contracts
    }, []);
    console.log('VolCon');
    console.log(volumeContracts);

    // Monitor registration status for success modal
    useEffect(() => {
        if (registerProductByVolumeStatus?.success && !registerProductByVolumeStatus?.loading) {
            // Registration was successful, the success modal will be shown
            // The status will be cleared when the modal is closed
        }
    }, [registerProductByVolumeStatus]);

    // Monitor error state for debugging
    useEffect(() => {
        console.log('🔍 Error state changed:', registerProductByVolumeStatus);
        if (registerProductByVolumeStatus?.error) {
            console.log('🚨 Error detected:', registerProductByVolumeStatus.errorMessage);
        }
    }, [registerProductByVolumeStatus]);

    const keyManager = new KeyManager(username);
    const privateKey = keyManager.deriveDataKey();
    const publicKey = keyManager.getPublicKey(privateKey);

    const registrationCardRef = useRef(null);
    const registrationInputRef = useRef(null);

    const onContractSet = (contract) => {
        console.log('📦 selected raw contract:', contract);
        setSelectedContract(contract);
        setSelectorOpen(false);
        setTimeout(() => {
            registrationCardRef.current?.scrollIntoView({ behavior: 'smooth', block: 'start' });
            registrationInputRef.current?.focus();
        }, 300);
    };

    // when the child’s “Register” button is clicked:
    const showConfirmSaveModal = (product) => {
        console.log('▶️ showConfirmSaveModal got:', product);
        // Clear any previous errors when starting a new registration
        if (registerProductByVolumeStatus?.error) {
            clearVolumeRegistrationError();
        }
        setPendingTrace(product);
        setConfirmSaveOpen(true);
    };

    // when the user clicks “Yes, save” in the modal:
    const confirmSave = () => {
        setConfirmSaveOpen(false);
        if (!pendingTrace || !selectedContract) return;

        // 1️⃣ build the little trace‐object array just like your old code expects
        const single = pendingTrace;
        const traceObj = {
            gtin: single.gtin,
            sn: single.sn,
            // exactly how the old payload made `trace`:
            trace: `${single.gtin}${single.sn}*`,
            // cycle: single.cycle,
        };

        console.log('▶️ ----------gtin got:', traceObj);
        console.log(
            '🛫 dispatching registerProductByVolume with:',
            selectedContract.obra_social,
            selectedContract.contrato,
            selectedContract,
            [traceObj],
            () => setPendingTrace(null),
        );
        // 2️⃣ dispatch with (os, contractId, traces[], callback)
        registerProductByVolume(
            selectedContract.obra_social, // os
            selectedContract.contrato,
            [traceObj], // traces array
            () => setPendingTrace(null), // successCallback
        );
    };

    return (
        <div className='i-container volume-registration-screen'>
            <ContractCard
                selectedContract={selectedContract}
                setSelectedContract={onContractSet}
                contracts={contracts}
                addableContracts={volumeContracts}
                getContractOs={getContractOs}
                privateKey={privateKey}
                publicKey={publicKey}
                selectorOpen={selectorOpen}
                setSelectorOpen={setSelectorOpen}
            />
            <ProductRegistrationCard
                selectedContract={selectedContract}
                inputRef={registrationInputRef}
                onRegisterClick={showConfirmSaveModal}
            />
            <ConfirmationModal
                show={confirmSaveOpen}
                icon={<i className='icon-check green' />}
                title={I18n.t('registration.confirmVolumeSaveModalTitle')}
                titleClassname='center-title'
                cancel={() => setConfirmSaveOpen(false)}
                submit={confirmSave}
                loading={registerProductByVolumeStatus.loading}
            />
            <TransactionsSuccessModal
                show={
                    registerProductByVolumeStatus?.success &&
                    !registerProductByVolumeStatus?.loading
                }
                onClick={() => {
                    clearVolumeRegistrationUI();
                }}
                text={I18n.t('registration.successfulModal.productRegistered')}
            />
            <SimpleModal show={registerProductByVolumeStatus?.error}>
                <div className='volume-registration-error-modal'>
                    <span className='error-title'>Error: Aplicación no registrada</span>
                    <i className='icon-exclamation red' />
                    <span className='modal-body-text'>
                        {registerProductByVolumeStatus?.errorMessage || 'Ha ocurrido un error'}
                    </span>
                    <Button
                        className='primary'
                        text='Continuar'
                        onClick={() => clearVolumeRegistrationError()}
                    />
                </div>
            </SimpleModal>
        </div>
    );
};
export default VolumeRegistrationScreen;
